import React from 'react';
import { Users } from 'lucide-react';
import { getInitials } from '../../utils/helpers';
import { API_BASE_URL } from '../../utils/constants';

/**
 * Component for displaying list of classmates
 *
 * @param {Object} props
 * @param {Array} props.classmates - Array of classmate data
 * @param {boolean} props.isEnrolled - Whether user is enrolled in the class
 */

const ClassmatesList = ({ classmates, isEnrolled }) => {
    return (
        <div className="bg-white shadow overflow-hidden sm:rounded-lg">
            <div className="px-4 py-5 sm:px-6 bg-gray-50 flex justify-between items-center">
                <div>
                    <h2 className="text-lg leading-6 font-medium text-gray-900">Classmates</h2>
                    <p className="mt-1 max-w-2xl text-sm text-gray-500">
                        Other students in this class
                    </p>
                </div>
                <div
                    className="flex h-8 w-8 items-center justify-center rounded-full bg-indigo-100 text-sm font-medium text-indigo-600">
                    {classmates.length}
                </div>
            </div>

            {!isEnrolled ? (
                <div className="p-6 text-center">
                    <Users className="h-10 w-10 text-gray-400 mx-auto mb-3" />
                    <p className="text-sm text-gray-500">
                        Join this class to see classmates
                    </p>
                </div>
            ) : classmates.length === 0 ? (
                <div className="p-6 text-center">
                    <Users className="h-10 w-10 text-gray-400 mx-auto mb-3" />
                    <p className="text-sm text-gray-500">
                        No other students in this class
                    </p>
                </div>
            ) : (
                <ul className="divide-y divide-gray-200 max-h-96 overflow-y-auto">
                    {classmates.map((student) => (
                        <li key={student.student_id} className="px-4 py-3">
                            <div className="flex items-center">

                                {student.profile_picture_url ? (
                                    <img
                                        src={API_BASE_URL + student.profile_picture_url}
                                        alt={student.name}
                                        className="h-10 w-10 rounded-full object-cover border-2 border-[#F7D1B6]"
                                    />
                                ) : (

                                    <div
                                        className="flex-shrink-0 h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-800 font-medium">
                                        {getInitials(student.name)}
                                    </div>
                                )}


                                <div className="ml-3">
                                    <p className="text-sm font-medium text-gray-900">{student.name}</p>
                                    <p className="text-xs text-gray-500">{student.email}</p>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ClassmatesList;